import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-pdfviewer',
  templateUrl: './pdfviewer.component.html',
  styleUrls: ['./pdfviewer.component.css']
})
export class PdfviewerComponent implements OnInit {

  constructor(public dialog: MatDialogRef<PdfviewerComponent>, @Inject(MAT_DIALOG_DATA) public data: string) { }

  ngOnInit() {
    if(this.data)
    {
      document.getElementById("iframeDisplay").innerHTML = "<embed src=\""+this.data+"\" width=\"1024\" height=\"700\"></embed>";
    }
  }

  Close()
  {
    this.dialog.close();
  }

}
